import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAppId } from '../context/AppIdContext';
import { useNavigate } from 'react-router-dom';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SpeakAndSearch = () => {
    // --- Context ---
    // Added userId to context extraction
    const { appId, language, userId } = useAppId();
    const navigate = useNavigate();

    // --- 1. Manual Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Speak And Search",
            pageSubtitle: "Search voter records using your voice or typing.",
            foundRecords: "Found {n} records. Showing page {p}.",
            placeholder: "Search by name...",
            listening: "Listening...",
            btnSearch: "Search",
            btnSearching: "Searching...",
            loadingText: "Fetching Records...",
            noRecords: "No records found.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            family: "Family",
            browserError: "Your browser does not support voice search. Please use Chrome.",
            fillError: "Please enter a name to search.",
            familyError: "Could not fetch family details.",
            print: "Print",
            addToGroup: "Add to Group",
            address: "Address :",
            addToGroupConfirm: "Are you sure you want to ADD this member to your group?",
            addToGroupSuccess: "Added to group successfully!",
            addToGroupFailed: "Failed to add to group.",
            addToGroupError: "An error occurred while adding to the group.",
            // Edit Mobile Popup Translations
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"
        },
        hi: {
            pageTitle: "बोलकर खोजें",
            pageSubtitle: "अपनी आवाज़ या टाइप करके मतदाता रिकॉर्ड खोजें।",
            foundRecords: "{n} रिकॉर्ड मिले। पृष्ठ {p} दिखाया जा रहा है।",
            placeholder: "नाम से खोजें...",
            listening: "सुन रहा है...",
            btnSearch: "खोजें",
            btnSearching: "खोज रहे हैं...",
            loadingText: "रिकॉर्ड प्राप्त कर रहे हैं...",
            noRecords: "कोई रिकॉर्ड नहीं मिला।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            family: "परिवार",
            browserError: "आपका ब्राउज़र वॉयस सर्च का समर्थन नहीं करता है। कृपया क्रोम का उपयोग करें।",
            fillError: "कृपया खोजने के लिए एक नाम दर्ज करें।",
            familyError: "परिवार का विवरण प्राप्त नहीं किया जा सका।",
            print: "प्रिन्ट",
            addToGroup: "ग्रूप में जोड़ें",
            address: "पता :",
            addToGroupConfirm: "क्या आप वाकई इस सदस्य को अपने ग्रूप में जोड़ना चाहते हैं?",
            addToGroupSuccess: "ग्रूप में सफलतापूर्वक जोड़ा गया!",
            addToGroupFailed: "ग्रूप में जोड़ने में विफल।",
            addToGroupError: "ग्रूप में जोड़ते समय एक त्रुटि हुई।",
            // Edit Mobile Popup Translations
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"
        },
        gu: {
            pageTitle: "બોલીને શોધો",
            pageSubtitle: "તમારો અવાજ અથવા ટાઈપ કરીને મતદાર રેકોર્ડ શોધો.",
            foundRecords: "{n} રેકોર્ડ મળ્યા. પૃષ્ઠ {p} દર્શાવે છે.",
            placeholder: "નામથી શોધો...",
            listening: "સાંભળી રહ્યા છે...",
            btnSearch: "શોધો",
            btnSearching: "શોધી રહ્યા છે...",
            loadingText: "રેકોર્ડ મેળવી રહ્યા છે...",
            noRecords: "કોઈ રેકોર્ડ મળ્યા નથી.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            family: "કુટુંબ",
            browserError: "તમારું બ્રાઉઝર વૉઇસ શોધને સપોર્ટ કરતું નથી. કૃપા કરીને Chrome નો ઉપયોગ કરો.",
            fillError: "શોધવા માટે કૃપા કરીને એક નામ દાખલ કરો.",
            familyError: "કુટુંબની વિગતો મેળવી શકાઈ નહીં.",
            print: "પ્રિનટ",
            addToGroup: "જૂથમાં ઉમેરો",
            address: "સરનામું :",
            addToGroupConfirm: "શું તમે ખરેખર આ સભ્યને તમારા જૂથમાં ઉમેરવા માંગો છો?",
            addToGroupSuccess: "જૂથમાં સફળતાપૂર્વક ઉમેરાયું!",
            addToGroupFailed: "જૂથમાં ઉમેરવામાં નિષ્ફળ.",
            addToGroupError: "જૂથમાં ઉમેરતી વખતે એક ભૂલ આવી.",
            // Edit Mobile Popup Translations
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"
        }
    };

    const txt = t[language || 'en'];

    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);

    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };

    // --- State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isListening, setIsListening] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    // --- Pagination State (Server Side) ---
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        if (!appId) {
            navigate("/");
        }
    }, [appId, navigate]);

    // 🔴 API Call updated to pass pageNumber and extract total records
    const fetchVoters = async (termOverride = null, page = 1) => {
        const termToUse = termOverride !== null ? termOverride : searchTerm;

        if (!appId || !termToUse.trim()) return;

        setLoading(true);
        setHasSearched(true);

        try {
            const response = await axios.post(
                `${BASE_URL}/api/quick_search`,
                {
                    app_id: appId,
                    search: termToUse,
                    pageNumber: page // Passing pageNumber to API
                }
            );

            if (response.data.success) {
                const resultData = response.data.data.result || [];
                setVoters(resultData);

                // 🔴 Extract total records from result2 only if provided, else keep existing if page > 1
                if (response.data.data.result2 && response.data.data.result2.length > 0) {
                    const r2 = response.data.data.result2[0];
                    const total = r2.total_record || r2.total_records || r2.Total || r2.total || Object.values(r2)[0] || 0;
                    setTotalRecords(total);
                } else if (page === 1) {
                    // Only fallback to resultData length if it's the very first page
                    setTotalRecords(resultData.length);
                }

                // If API returns total_pages, use it. Otherwise, calculate dynamically.
                if (response.data.data.total_pages) {
                    setTotalPages(response.data.data.total_pages);
                } else {
                    // Fallback logic if API doesn't send total_pages
                    if (resultData.length >= itemsPerPage) {
                        setTotalPages(Math.max(page + 1, totalPages));
                    } else {
                        setTotalPages(page);
                    }
                }
                setCurrentPage(page);
            } else {
                setVoters([]);
                setTotalPages(1);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error("Error fetching voters:", error);
            setVoters([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    // --- Voice Search Logic ---
    const startListening = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(txt.browserError);
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = language === 'hi' ? 'hi-IN' : 'en-US';
        recognition.interimResults = false;

        recognition.onstart = () => setIsListening(true);

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            const cleanTranscript = transcript.replace(/[^a-zA-Z0-9\u0900-\u097F ]/g, "");
            setSearchTerm(cleanTranscript);
            fetchVoters(cleanTranscript, 1);
        };

        recognition.onerror = (event) => {
            console.error("Speech error", event.error);
            setIsListening(false);
        };

        recognition.onend = () => setIsListening(false);
        recognition.start();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            fetchVoters(null, 1);
        }
    };

    // --- Add to Group API Call ---
    const handleAddToGroup = async (voter) => {
        // Show confirmation alert using translated text
        const isConfirmed = window.confirm(txt.addToGroupConfirm);

        if (!isConfirmed) {
            return; // User cancelled the operation
        }

        try {
            const payload = {
                app_id: appId?.toString(),
                user_id: userId?.toString() || appId?.toString(),
                idcard: voter.idcard_no
            };

            const response = await axios.post(`${BASE_URL}/api/ins_my_group`, payload);

            if (response.data.success) {
                alert(txt.addToGroupSuccess);
            } else {
                alert(txt.addToGroupFailed);
            }
        } catch (error) {
            console.error("Error adding to group:", error);
            alert(txt.addToGroupError);
        }
    };

    // 🔴 Calculate serial numbers correctly based on current page
    const currentVoters = voters;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            fetchVoters(null, pageNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert(txt.mobileNotAvailable);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'સ્ત્રી')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert(txt.mobileNotAvailable);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'સ્ત્રી')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className='app-container p-4 custom-responsive-container'>

            <Header title={txt.pageTitle} />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- PROFESSIONAL ACTION BAR --- */}
            <div className="filter-container mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="search-wrapper-modern">
                    <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        className="search-input-modern"
                        type="text"
                        placeholder={isListening ? txt.listening : txt.placeholder}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                    <button
                        className={`mic-btn-modern ${isListening ? 'listening' : ''}`}
                        onClick={startListening}
                        title="Click to Speak"
                        type="button"
                    >
                        {isListening ? (
                            <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="2" /></svg>
                        ) : (
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" /></svg>
                        )}
                    </button>
                    <button
                        className="search-btn-icon"
                        onClick={() => fetchVoters(null, 1)}
                        disabled={loading}
                        type="button"
                        title={txt.btnSearch}
                    >
                        {loading ? (
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="spinner-icon"><path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                        ) : (
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                        )}
                    </button>
                </div>
                
                {/* --- Count Display --- */}
                {!loading && hasSearched && voters.length > 0 && (
                    <div className="count-display-modern slide-up-element">
                        <span className="count-label">Total :</span>
                        <span className="count-number">{totalRecords.toLocaleString()}</span>
                    </div>
                )}
            </div>
            {loading && (
                <div className="loader-wrapper text-center p-5">
                    <div className="spinner"></div>
                    <p className="mt-3">{txt.loadingText}</p>
                </div>
            )}


            {!loading && hasSearched && voters.length === 0 && (
                <div className="text-center text-muted p-5">{txt.noRecords}</div>
            )}

            {/* --- RESULTS GRID --- */}
            <div className="row g-4 mt-1 pb-5">
                {!loading && currentVoters.map((voter, index) => (
                    <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                        <div className="voter-card-clean h-100">
                            {/* Name Header */}
                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                    <span className="voter-name-bold ms-2">{voter.eng_f_name} {voter.eng_surname}</span>
                                </div>
                                <button
                                    onClick={() => handleAddToGroup(voter)}
                                    style={{
                                        backgroundColor: '#eff6ff',
                                        color: '#2563eb',
                                        border: '1px solid #bfdbfe',
                                        borderRadius: '20px',
                                        padding: '4px 10px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseOver={(e) => { e.target.style.backgroundColor = '#dbeafe'; }}
                                    onMouseOut={(e) => { e.target.style.backgroundColor = '#eff6ff'; }}
                                >
                                    + {txt.addToGroup}
                                </button>
                            </div>

                            <div className="voter-body position-relative">
                                <div
                                    className="map-icon-wrapper"
                                    style={{ cursor: 'pointer', zIndex: 10 }}
                                    title="View on Google Maps"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const address = voter.eng_localityid;
                                        if (address && address !== "N/A") {
                                            // ગુગલ મેપ્સમાં એડ્રેસ સર્ચ કરવા માટેની લિંક
                                            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                        } else {
                                            alert(txt.addressNotAvailable);
                                        }
                                    }}
                                >
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                </div>
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="label">{txt.mobile}</span>
                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                    <svg
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingVoter(voter);
                                            setNewMobile(voter.contact_no || '');
                                            setIsEditMobileOpen(true);
                                        }}
                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                    </svg>
                                </div>
                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                            </div>

                            <div className="voter-actions">
                                <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                            alert(txt.mobileNotAvailable);
                                        }
                                        else {
                                            window.open(`tel:${voter.contact_no}`, '_blank');
                                        }
                                    }}

                                />
                                <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                <WhatsappSlipButton voter={voter} />
                                <PracharButton voter={voter} />
                                <ActionButton
                                    icon="🖨"
                                    color="#f97316"
                                    label={txt.print}
                                    onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                />
                                <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Pagination UI rendering */}
            {!loading && totalPages > 1 && (
                <div className="pagination-wrapper">
                    <div className="pagination-content">
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <div className="page-numbers">
                            {getPageNumbers().map((number, index) => (
                                <React.Fragment key={index}>
                                    {number === '...' ? (<span className="page-dots">...</span>) : (
                                        <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || currentVoters.length < itemsPerPage}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}

            <style jsx>{`
                                .filter-container-modern { display: flex; justify-content: flex-start; align-items: center; }
                
                /* --- COUNT DISPLAY --- */
                .count-display-modern {
                    display: inline-flex;
                    align-items: center;
                    background: #eff6ff;
                    padding: 8px 16px;
                    border-radius: 12px;
                    border: 1px solid #bfdbfe;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05);
                    gap: 8px;
                }
                .count-label {
                    color: #1e40af;
                    font-weight: 600;
                    font-size: 15px;
                }
                .count-number {
                    background: transparent;
                    color: #1d4ed8;
                    font-weight: 800;
                    font-size: 16px;
                }
                
                .search-wrapper-modern { 
                    position: relative; 
                    width: 100%; 
                    max-width: 450px; 
                    display: flex;
                    align-items: center;
                }
                
                .search-icon-modern { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    width: 20px; 
                    height: 20px; 
                    color: #94a3b8; 
                    pointer-events: none; 
                    z-index: 1; 
                }
                
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 16px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 12px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    background-color: #ffffff; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                    padding-right: 100px; 
                    height: 48px;
                }
                
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }
                
                .btn-search-trigger { 
                    display: flex; 
                    align-items: center; 
                    gap: 8px; 
                    background-color: #2563eb; 
                    color: #ffffff; 
                    padding: 12px 20px; 
                    border: none; 
                    border-radius: 10px; 
                    font-size: 14px; 
                    font-weight: 600; 
                    cursor: pointer; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2); 
                    white-space: nowrap; 
                }
                
                .btn-search-trigger:hover { 
                    background-color: #1d4ed8; 
                    transform: translateY(-1px); 
                }
                
                .mic-btn-modern { 
                    position: absolute; 
                    right: 52px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    background: transparent; 
                    border: none; 
                    cursor: pointer; 
                    color: #64748b; 
                    padding: 6px; 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                    transition: 0.2s; 
                    z-index: 2; 
                    width: 32px; 
                    height: 32px;
                }
                
                .mic-btn-modern:hover { 
                    color: #2563eb; 
                }
                
                .mic-btn-modern.listening { 
                    color: #ef4444; 
                    animation: pulse-red 1.5s infinite; 
                }
                
                .search-btn-icon {
                    position: absolute;
                    right: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #2563eb;
                    border: none;
                    border-radius: 8px;
                    cursor: pointer;
                    color: white;
                    padding: 8px 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: 0.2s;
                    z-index: 2;
                    height: 36px;
                    min-width: 36px;
                }
                
                .search-btn-icon:hover { 
                    background-color: #1d4ed8; 
                }
                
                .search-btn-icon:disabled { 
                    background-color: #94a3b8; 
                    cursor: not-allowed; 
                }
                
                @keyframes pulse-red { 
                    0% { opacity: 1; transform: translateY(-50%) scale(1); } 
                    50% { opacity: 0.7; transform: translateY(-50%) scale(1.1); } 
                    100% { opacity: 1; transform: translateY(-50%) scale(1); } 
                }
                
                /* Pagination styles */
                .pagination-wrapper { 
                    display: flex; 
                    justify-content: center; 
                    padding: 20px 0; 
                    position: sticky; 
                    bottom: 20px; 
                    z-index: 50; 
                    pointer-events: none; 
                }
                
                .pagination-content { 
                    background: white; 
                    border: 1px solid #E2E8F0; 
                    border-radius: 50px; 
                    padding: 8px 16px; 
                    display: flex; 
                    align-items: center; 
                    gap: 10px; 
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); 
                    pointer-events: auto; 
                }
                
                .pagination-nav-btn { 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                    width: 36px; 
                    height: 36px; 
                    border-radius: 50%; 
                    background: transparent; 
                    border: none; 
                    color: #2563EB; 
                    cursor: pointer; 
                }
                
                .pagination-nav-btn:disabled { 
                    color: #CBD5E1; 
                    cursor: not-allowed; 
                }
                
                .page-numbers { 
                    display: flex; 
                    gap: 5px; 
                    align-items: center; 
                }
                
                .page-num-btn { 
                    width: 32px; 
                    height: 32px; 
                    border-radius: 50%; 
                    border: 1px solid transparent; 
                    background: transparent; 
                    color: #475569; 
                    font-weight: 600; 
                    font-size: 14px; 
                    cursor: pointer; 
                }
                
                .page-num-btn.active { 
                    background-color: #2563EB; 
                    color: white; 
                }
                
                .page-dots { 
                    color: #94A3B8; 
                    font-weight: bold; 
                    padding: 0 4px; 
                }

                .loader-wrapper {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    min-height: 40vh;
                    width: 100%;
                }

                .spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #E5E7EB;
                    border-top: 4px solid #2563EB;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 12px;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                @media (max-width: 640px) { 
                    .filter-container { 
                        flex-direction: row; 
                        align-items: center; 
                        gap: 8px; 
                    } 
                    
                    .search-wrapper-modern {
                        flex: 1;
                        max-width: none;
                    }
                    
                    .search-input-modern {
                        padding: 10px 16px 10px 36px;
                        font-size: 13px;
                        padding-right: 90px;
                        height: 44px;
                    }
                    
                    .search-icon-modern {
                        left: 10px;
                        width: 16px;
                        height: 16px;
                    }

                    .mic-btn-modern {
                        right: 48px;
                        padding: 4px;
                        width: 28px;
                        height: 28px;
                    }

                    .mic-btn-modern svg {
                        width: 16px;
                        height: 16px;
                    }

                    .search-btn-icon {
                        right: 6px;
                        padding: 6px 10px;
                        height: 32px;
                        min-width: 32px;
                    }

                    .search-btn-icon svg {
                        width: 14px;
                        height: 14px;
                    }
                    
                    .btn-search-trigger { 
                        width: auto; 
                        padding: 10px 12px;
                        font-size: 13px;
                        gap: 4px;
                        height: 46px;
                    } 
                    
                    .btn-search-trigger svg {
                        width: 16px;
                        height: 16px;
                    }
                    
                    .row.g-4 {
                        margin-left: -8px;
                        margin-right: -8px;
                    }
                    
                    [class*="col-"] {
                        padding-left: 8px;
                        padding-right: 8px;
                    }
                    
                    .pagination-content {
                        padding: 6px 12px;
                    }
                    
                    .page-num-btn {
                        width: 28px;
                        height: 28px;
                        font-size: 12px;
                    }
                    
                    .pagination-nav-btn {
                        width: 32px;
                        height: 32px;
                    }
                }

                @media (max-width: 480px) {
                    .search-input-modern {
                        padding: 8px 12px 8px 32px;
                        font-size: 12px;
                        padding-right: 80px;
                        height: 40px;
                    }

                    .search-icon-modern {
                        left: 8px;
                        width: 14px;
                        height: 14px;
                    }

                    .mic-btn-modern {
                        right: 44px;
                        padding: 3px;
                        width: 24px;
                        height: 24px;
                    }

                    .mic-btn-modern svg {
                        width: 14px;
                        height: 14px;
                    }

                    .search-btn-icon {
                        right: 4px;
                        padding: 4px 8px;
                        height: 28px;
                        min-width: 28px;
                    }

                    .search-btn-icon svg {
                        width: 12px;
                        height: 12px;
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default SpeakAndSearch;
